import styles from "./SinglePreviewFromEditState.module.css";
import { JAPANESE_REGEX } from "../../../constants";
import { useState } from "react";
const SinglePreviewFromEditState = (state) => {
  console.log("Inside SinglePreviewFROM EDIT STATE");
  console.log(state);
  let {
    sec03textbox,
    sec04textbox,
    titleText,
    backCover01Text,
    backCover02Text,
    uploadedImage,
  } = state["state"];
  function getBackCover01Text() {
    return sec03textbox === "その他（内容を入力する）"
      ? backCover01Text
      : sec03textbox;
  }
  function getBackCover02Text() {
    return sec04textbox === "その他（内容を入力する）"
      ? backCover02Text
      : sec04textbox === "表紙と同じ"
      ? titleText
      : sec04textbox;
  }
  const [verticalImage, setVerticalImage] = useState(false);
  function handleImageLoad(event) {
    const { naturalWidth, naturalHeight } = event.target;
    setVerticalImage(naturalWidth >= naturalHeight ? false : true);
  }
  return (
    <div className={styles.preview_section}>
      <div className={styles.preview_column_1}>
        <div className={styles.preview_sub_1}>背表紙タイトル</div>
        <div className={styles.preview_column_main_01}>
          <div
            className={
              JAPANESE_REGEX.test(getBackCover01Text())
                ? styles.preview_column_main_01_top
                : styles.preview_column_main_01_top_english
            }
          >
            {/* 七五三 */}
            {getBackCover01Text()}
          </div>
          <div
            className={
              JAPANESE_REGEX.test(getBackCover02Text())
                ? styles.preview_column_main_02_top
                : styles.preview_column_main_02_top_english
            }
          >
            {/* 光輝 大輝 */}
            {getBackCover02Text()}
          </div>
        </div>
      </div>
      <div className={styles.preview_column_2}>
        <div className={styles.preview_sub_2}>タイトル</div>
        <div className={styles.preview_column_main_02}>
          <div className={styles.preview_title_div}>
            {/* <div className={`${styles.preview_title_text_col} lang=ja`}>
          大輝
        </div>
        <div className={`${styles.preview_title_text_col} lang=ja`}>
          光輝
        </div> */}
            {JAPANESE_REGEX.test(titleText) &&
              titleText.split(" ").map((item, index) => {
                return (
                  <div className={`${styles.preview_title_text_col} lang=ja`}>
                    {item}
                  </div>
                );
              })}
            {!JAPANESE_REGEX.test(titleText) && (
              <div className={`${styles.preview_title_text_col_eng}`}>
                {titleText}
              </div>
            )}
          </div>

          <div className={styles.preview_image_div}>
            <div className={styles.preview_image_text}>表紙写真</div>
            <div className={styles.preview_image_main}>
              <img
                src={uploadedImage}
                onLoad={handleImageLoad}
                alt={"uploaded_image"}
                style={{
                  maxHeight: verticalImage ? "450px" : "300px",
                  maxWidth: !verticalImage ? "450px" : "300px",
                }}
                crossOrigin="anonymous"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SinglePreviewFromEditState;
